import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommandesService } from 'src/app/services/commandes/commandes.service';

@Component({
  selector: 'app-detais-virement',
  templateUrl: './detais-virement.component.html',
  styleUrls: ['./detais-virement.component.css']
})
export class DetaisVirementComponent implements OnInit {

  statusCmds: any = []
  
  constructor(public dialogRef: MatDialogRef<DetaisVirementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cmdsService: CommandesService,) { }

  ngOnInit(): void {
    this.cmdsService.getLabeledStatus().then(
      (lst) => {
        this.statusCmds = lst
      }
    )
  }

}
